import { motion } from "framer-motion";
import { trackTelegramClick, TELEGRAM_URL } from "@/config";

const VARIANTS = {
    purple:
        "bg-gradient-to-b from-[#B44BFF] to-[#8B1FD6] text-white shadow-[0_12px_45px_-10px_rgba(160,32,240,0.7)] hover:from-[#c466ff] hover:to-[#9a2fe6]",
    outline:
        "border border-neon/60 bg-neon/5 text-[#E2C6FF] hover:bg-neon/15",
};

const CtaButton = ({
    location = "Hero",
    variant = "purple",
    className = "",
    children,
    testId,
    small = false,
}) => (
    <motion.a
        href={TELEGRAM_URL}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => trackTelegramClick(location)}
        data-testid={testId}
        whileHover={{ scale: 1.03, y: -2 }}
        whileTap={{ scale: 0.96 }}
        transition={{ type: "spring", stiffness: 400, damping: 22 }}
        className={`inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-full font-display font-extrabold uppercase tracking-wide transition-colors duration-300 ${
            small
                ? "px-4 py-2.5 text-[10px] sm:px-5 sm:text-[11px]"
                : "px-8 py-4 text-sm sm:text-base"
        } ${VARIANTS[variant]} ${className}`}
    >
        {children}
    </motion.a>
);

export default CtaButton;
